<template>
  <div class="app-change-tariff-summary">
      <slot name="txtSummary">
        <h1>Tarifwechsel</h1>
        <p>Wechsel in den folgenden Tarif: {{ selectedTariffName }}</p>
        <p>Die Vertragszusammenfassung finden Sie <span class="link" @click="download()">hier</span>.</p>
      </slot>
    <Stepper
      @prev="prev()"
      @next="next()"
      :loading-next="loading"
    >
      <template #btnPrev><slot name="btnPrevSummary"></slot></template>
      <template #btnNext><slot name="btnNextSummary"></slot></template>
    </Stepper>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import Stepper from '@/components/generic/Stepper.vue'
import { stepName as previousStep } from '@/components/process/generic/Tariff/rossmann/Input.vue'
import { stepName as nextStep } from '@/components/process/generic/Tariff/rossmann/Success.vue'
import axios from 'axios'
import FileSaver from 'file-saver'

export const stepName = 'summary'

export default {
  name: 'ChangeTariffSummary',
  data () {
    return {
      loading: false
    }
  },
  methods: {
    ...mapActions('changeTariff', [
      'confirmChangeTariff'
    ]),
    ...mapMutations('changeTariff', [
      'changeStep'
    ]),
    prev () {
      this.changeStep(previousStep)
    },
    async next () {
      this.loading = true
      await this.confirmChangeTariff({
        nextStep: nextStep
      })
      this.loading = false
    },
    download () {
      const me = this

      axios.get(this.contractUrl, {
        baseURL: this.$config.apiUrl || '',
        headers: {
          Authorization: `Bearer ${this.accessToken}`,
          Accept: 'application/pdf'
        },
        responseType: 'blob'
      }).then((response) => {
        const file = new Blob([response.data], { type: response.headers['content-type'] })
        FileSaver.saveAs(file, 'Vertragszusammenfassung.pdf')
      }).catch((reason) => {
        me.$store.commit('addError', 'Fehler beim Abrufen der Datei. (' + reason.response.status + ')')
      })
    }
  },
  computed: {
    ...mapGetters('changeTariff', [
      'selectedTariffName', 'contractUrl'
    ]),
    ...mapGetters([
      'accessToken'
    ]),
    slotData: function () {
      return {
        tariffName: this.selectedTariffName
      }
    }
  },
  components: {
    Stepper
  }
}
</script>
